import styled from 'styled-components'
import { ScoreDisplay } from '../atoms/ScoreDisplay/ScoreDisplay'

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 24px 8px 24px;
  // border-bottom: 1px solid ${({ theme }) => theme.colors.border.light};
`

export const HeaderContent = styled.div`
  flex: 1;
`

export const PageTitle = styled.h1`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 8px 0;
  letter-spacing: -0.5px;
`

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`

export const ScoreDisplayWrapper = styled(ScoreDisplay)`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 12px;
  padding: 12px 20px;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`
